module.exports = __webpack_public_path__ + "static/img/hua16.44ca600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua16.png
// module id = Kd8d
// module chunks = 22